module.exports = __webpack_public_path__ + "static/img/1.c7b4699a.jpg";